import { render } from "./employees.vue?vue&type=template&id=4c6076fa&scoped=true"
import script from "./employees.vue?vue&type=script&lang=js"
export * from "./employees.vue?vue&type=script&lang=js"

import "./employees.vue?vue&type=style&index=0&id=4c6076fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6076fa"]])

export default __exports__